import { SUPPLIER_TYPES, PRODUCT_TYPES } from "../TYPES";

export default [
  {
    title: "Accommodations",
    module: PRODUCT_TYPES.ROOM,
    restrictTo: [SUPPLIER_TYPES.HOTEL],
  },
  {
    title: "Meals",
    module: PRODUCT_TYPES.MEAL,
    restrictTo: [SUPPLIER_TYPES.HOTEL, SUPPLIER_TYPES.RESTAURANT],
  },
  {
    title: "Excursions",
    module: PRODUCT_TYPES.EXCURSION,
    restrictTo: [SUPPLIER_TYPES.HOTEL, SUPPLIER_TYPES.EXCURSION, SUPPLIER_TYPES.PARK],
  },
  {
    title: "Tour Guide Services",
    module: PRODUCT_TYPES.TOUR,
    restrictTo: [SUPPLIER_TYPES.TOUR_GUIDE],
  },
  {
    title: "Tour Leader",
    module: PRODUCT_TYPES.TOUR_LEADER,
    restrictTo: [SUPPLIER_TYPES.TOUR_GUIDE],
  },
  {
    title: "Transportation",
    module: PRODUCT_TYPES.TRANS,
    restrictTo: [SUPPLIER_TYPES.TRANSPORT, SUPPLIER_TYPES.TOUR_GUIDE],
  },
  {
    title: "Expense",
    module: PRODUCT_TYPES.EXPENSE,
  },
];
